const DEFAULT_REASON_GROUP_FIELD = 'department';
const REASON_GROUP_CONFIG_KEYS = [
  'downtimeReasonConfig',
  'downtimeReasonGroupBy',
  'downtimeReasonGrouping',
];
const SUPPORTED_REASON_GROUP_FIELDS = new Set([
  'department',
  'category',
]);

export const normalizeSchema = (schema) => {
  if (!schema) {
    return [];
  }

  if (typeof schema === 'string') {
    try {
      return normalizeSchema(JSON.parse(schema));
    } catch (error) {
      return [];
    }
  }

  if (Array.isArray(schema)) {
    return schema;
  }

  if (typeof schema === 'object') {
    return [schema];
  }

  return [];
};

const normalizeConfigValue = (config) => {
  if (typeof config === 'string') {
    return config.trim().toLowerCase();
  }

  if (Array.isArray(config)) {
    const firstConfig = config.find((item) => item && typeof item === 'object');

    if (firstConfig) {
      return normalizeConfigValue(firstConfig.value);
    }
  }

  if (config && typeof config === 'object') {
    return normalizeConfigValue(config.value);
  }

  return '';
};

export const getDowntimeReasonGroupField = (schema) => {
  const normalizedSchema = normalizeSchema(schema);
  const schemaDetails = normalizedSchema.find((item) => (
    item
    && typeof item === 'object'
    && REASON_GROUP_CONFIG_KEYS.some((key) => item[key] !== undefined)
  ));

  const configKey = schemaDetails
    ? REASON_GROUP_CONFIG_KEYS.find((key) => schemaDetails[key] !== undefined)
    : null;

  const configuredField = configKey
    ? normalizeConfigValue(schemaDetails[configKey])
    : '';

  return SUPPORTED_REASON_GROUP_FIELDS.has(configuredField)
    ? configuredField
    : DEFAULT_REASON_GROUP_FIELD;
};
